export const ActionTypes = {
  CLEAR_GROUP: "CLEAR_GROUP",
  GET_GROUP: "GET_GROUP",
  GET_GROUP_RESULTS: "GET_GROUP_RESULTS",
  CREATE_PRICING_LEVEL: "CREATE_PRICING_LEVEL",
  UPDATE_PRICING_LEVEL: "UPDATE_PRICING_LEVEL",
  GET_PRICING_LEVEL: "GET_PRICING_LEVEL",
  LIST_PRICING_LEVELS: "LIST_PRICING_LEVELS",
  CREATE_PRICING_LEVEL_RESULTS: "CREATE_PRICING_LEVEL_RESULTS",
  UPDATE_PRICING_LEVEL_RESULTS: "UPDATE_PRICING_LEVEL_RESULTS",
  GET_PRICING_LEVEL_RESULTS: "GET_PRICING_LEVEL_RESULTS",
  LIST_PRICING_LEVELS_RESULTS: "LIST_PRICING_LEVELS_RESULTS",
  GET_USER_PERMISSIONS: "GET_USER_PERMISSIONS",
  GET_USER_PERMISSIONS_RESULTS: "GET_USER_PERMISSIONS_RESULTS",
} as const;
